module.exports = __webpack_public_path__ + "static/CircularStd-Book-829012af195c90c00bac2953653768a8.woff";